import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'
class AddBanner extends React.Component {
  state = {
    cruise_banner_img: '',
    isData: false,
    Edit: false,
  }
  handleChangeImage = (e) => {
    this.setState({ [e.target.name]: e.target.files[0] })
    this.setState({ Edit: false })
    this.setState({ img: URL.createObjectURL(e.target.files[0]) })
  }
  addBanner = () => {
    var that = this
    var data = new FormData()
    that.setState({ isSaving: true })
    var cruiseId = this.props.match.params.boatId
    data.append('cruise_id', cruiseId)
    data.append('cruise_banner_img', this.state.cruise_banner_img)
    this.setState({ isData: true })
    axios
      .post(Constant.getAPI() + '/cruise/add-cruise-banner', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        this.setState({ isData: false })
        if (res.status) {
          Swal.fire({
            title: 'Banner Added Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
        window.location.href = `#/boatsmaster/${this.props.match.params.boatType}/${this.props.match.params.boatId}/banner-lists`
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  onSaveData = () => {
    var that = this
    that.setState({ isSaving: true })

    that.addBanner()
  }
  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>{this.props.match.params.boatType} Banner Add</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link
                        to={`/boatsmaster/${this.props.match.params.boatType}/${this.props.match.params.boatId}/banner-lists`}
                      >
                        {this.props.match.params.boatType} Banner List
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">Banner add</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    <ul
                      className="nav nav-tabs  tabs"
                      role="tablist"
                    >
                      {this.state.language_data !== undefined && this.state.language_data !== []
                        ? this.state.language_data.map((language) => (
                            <li
                              className="nav-item"
                              key={language.id}
                              onClick={this.handleLanguage.bind(this, language.id)}
                            >
                              <a
                                className={this.state.language_id === language.id ? 'nav-link active' : 'nav-link'}
                                id={'language_' + language.id}
                                data-toggle="tab"
                                href={'#tyre_brand_' + language.id}
                                role="tab"
                                aria-controls={'tyre_brand_' + language.id}
                                aria-selected="true"
                              >
                                {language.name}{' '}
                              </a>
                            </li>
                          ))
                        : ''}
                    </ul>
                    <div className="tab-content tabs">
                      <div
                        className="tab-pane  active"
                        id={'flight_class_add_' + this.state.language_id}
                        role="tabpanel"
                        aria-labelledby=""
                      >
                        <div className="">
                          <div className="card-body">
                            <div className="row">
                              <div className="col-md-6">
                                <div className="row">
                                  <div className="col-sm-3"> Image</div>
                                  <div className="col-sm-6">
                                    <div className="form-group">
                                      <div>
                                        <input
                                          type="file"
                                          id="img"
                                          name="cruise_banner_img"
                                          accept="image/*"
                                          className="w-100"
                                          onChange={this.handleChangeImage}
                                        />
                                      </div>
                                    </div>
                                    {this.state.Edit ? (
                                      <img
                                        width="250px"
                                        height="200px"
                                        src={Constant.getImage() + this.state.cruise_banner_img}
                                        alt="img"
                                      />
                                    ) : (
                                      <img
                                        width="250px"
                                        height="200px"
                                        src={this.state.img}
                                        alt="img"
                                      />
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="card-footer">
                              <div className="row">
                                <div className="text-right col-6 offset-6">
                                  <Link
                                    to={`/boatsmaster/${this.props.match.params.boatType}/${this.props.match.params.boatId}/banner-lists`}
                                    className="btn btn-outline-secondary m-2 "
                                  >
                                    <i className="icofont icofont-rounded-double-left"></i>
                                    Back
                                  </Link>
                                  {this.state.isData ? (
                                    <button
                                      className="btn btn-grd-disabled mr-2"
                                      disabled
                                    >
                                      Saving...!
                                    </button>
                                  ) : (
                                    <button
                                      onClick={this.onSaveData}
                                      className="btn hor-grd btn-grd-inverse offset-1"
                                    >
                                      <i className="ti-save"></i>Save
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AddBanner
